window.addProductToCart = function(variantId) {
  // אם לא נשלח ID, השתמש בברירת מחדל
  var VARIANT_ID = variantId || '44713437528258';
  
  // התחל loading
  document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
  
  // מצא את ה-section ID של העגלה
  var cartDrawer = document.querySelector('cart-drawer');
  var sectionId = cartDrawer ? cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '') : '';
  
  // צור FormData עם sections
  var formData = new FormData();
  formData.append('id', VARIANT_ID);
  formData.append('quantity', '1');
  formData.append('sections', sectionId);
  formData.append('sections_url', window.Shopify.routes.root + 'variants/' + VARIANT_ID);
  
  // שלח בקשה
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(function(response) {
    return response.json();
  })
  .then(function(responseData) {
    // טען את כל העגלה מחדש
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        // הוסף את ה-sections מהתגובה
        cart.sections = responseData.sections || {};
        return cart;
      });
  })
  .then(function(cart) {
    // סיים loading
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    
    // שדר אירוע cart:change עם כל המידע
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'variant:add',
        cart: cart,
        onSuccessDo: 'force_open_drawer'
      }
    }));
  })
  .catch(function(error) {
    console.error('Error:', error);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    
    // אם יש שגיאה, נסה לרענן את העגלה בכל זאת
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  });
};